export const ROUTES = {
  AUTH: {
    LOGIN: "/login",
    FORGOT_PASSWORD: "/forgot-password",
    VERIFY_OTP: "/verify-otp",
    CREATE_PASSWORD: "/create-password",
    CHANGE_PASSWORD: "/change-password",
  },
  DASHBOARD: {
    HOME: "/",
    ORDER_MANAGEMENT: "/order-management",
    ORDER_CREATE: "/order-management/create",
    ORDER_EDIT: (id: string) => `/order-management/${id}/edit`,
    ORDER_VIEW: (id: string) => `/order-management/${id}`,
    PRODUCT_MANAGEMENT: "/product-management",
    PRODUCT_VIEW: (id: string) => `/product-management/${id}`,
    RETURNS: "/returns",
    ACCOUNT_SETTINGS: "/account-settings",
  },
  ROOT: "/",
} as const;
